import { render, staticRenderFns } from "./Examination_list.vue?vue&type=template&id=49856a3b&scoped=true"
import script from "./Examination_list.vue?vue&type=script&lang=js"
export * from "./Examination_list.vue?vue&type=script&lang=js"
import style0 from "./Examination_list.vue?vue&type=style&index=0&id=49856a3b&prod&scoped=true&lang=css"
import style1 from "./Examination_list.vue?vue&type=style&index=1&id=49856a3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49856a3b",
  null
  
)

export default component.exports